import classNames from 'classnames'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import ProfileOverview from '../ProfileOverview'

import { ReactComponent as ModalXIcon } from '../../../../../../assets/images/common/icons/modal-X-icon.svg'
import classes from './WaitlistViewAllModal.module.scss'
import SubmitButton from '../../../../../common/buttons/SubmitButton'
import { Fragment } from 'react'

const WaitlistStudentRow = ({ user: student, createdAt }) => (
  <>
    <div className='d-flex'>
      <ProfileOverview student={student} />
    </div>
    <div className='d-flex text-right justify-content-end'>
      {student.email ? (
        <p className={classNames(classes.emailText, 'mb-0 font-weight-bold')} title={student.email}>{student.email}</p>
      ) : (
        <ul className={classes.multipleValueList}>
          {student.familyAdminsEmails.map((email, idx) => (
            <li key={idx}>
              <p className={classNames(classes.emailText, 'mb-1')} title={email}>{email}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
    <div className='d-flex'>
      <p className={classes.date}>{moment(createdAt).format('L h:ma')}</p>
    </div>
    <div className='d-flex'>
      <p className='mb-0'>{student.phone || '+40123032193'}</p>
    </div>
  </>
)

WaitlistStudentRow.propTypes = {
  user: PropTypes.object,
  createdAt: PropTypes.string,
}

const WaitlistViewAllModal = ({
  isOpen,
  onClose,
  waitlist,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={t('programs.manage.waitlistViewAll.modalLabel')}
      className={classNames(classes.waitlistViewAllModalContent)}
    >
      <div id='WaitlistViewAllModal'>
        <div className='animated fadeIn'>
          <div className='d-flex justify-content-between text-align-right mb-4'>
            <div>
              <h6 className={classes.title}>
                {t('programs.manage.waitlistViewAll.title', { count: waitlist.length })}
              </h6>
            </div>
            <ModalXIcon role='button' aria-label={t('programs.manage.waitlistViewAll.closeModal')} onClick={onClose} />
          </div>
          <div className={classes.list}>
            {waitlist.map(({ id, ...attrs }) => <WaitlistStudentRow key={id} {...attrs} />)}
          </div>
          <div className='d-flex justify-content-center'>
            <SubmitButton buttonMessage={t('common.close')} onClick={onClose} className={classes.closeButton} />
          </div>
        </div>
      </div>
    </Modal>
  )
}

WaitlistViewAllModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  waitlist: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    createdAt: PropTypes.string,
    user: PropTypes.any,
  })),
}

export default WaitlistViewAllModal
